import React from 'react';
import './Travel.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import t1 from '../images/t1.png';
import t2 from '../images/t2.png';
import t3 from '../images/t3.png';
import t4 from '../images/t4.png';
import t5 from '../images/t5.jpg';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 2,
    slidesToSlide: 1,
  },
};

class Travel extends React.Component {
  render() {
    return (
      <div className="travel jumbotron-fluid">
        <h1>
          <span>T</span>ravel
        </h1>
        <hr></hr>
        <Carousel
          swipeable={true}
          draggable={false}
          showDots={true}
          renderDotsOutside={true}
          responsive={responsive}
          ssr={true}
          infinite={true}
          autoPlay={false}
          autoPlaySpeed={10000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          containerClass="carousel-container"
          removeArrowOnDeviceType={['tablet', 'mobile']}
          deviceType={this.props.deviceType}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          <div>
            <a href="https://jelajahgarut.com/">
              <img src={t1} className="img-fluid" alt=" " />
              <h5>Jelajah Garut</h5>
            </a>
          </div>
          <div>
            <a href="https://digarut.com/">
              <img src={t2} className="img-fluid" alt=" " />
              <h5>Di Garut</h5>
            </a>
          </div>
          <div>
            <a href="https://www.doyanjalan.com/">
              <img src={t3} className="img-fluid" alt=" " />
              <h5>Doyan Jalan</h5>
            </a>
          </div>
          <div>
            <a href="https://pesonaindo.com/">
              <img src={t4} className="img-fluid" alt=" " />
              <h5>Pesona Indo</h5>
            </a>
          </div>
          <div>
            <a href="https://sanjayatour.com/">
              <img src={t5} className="img-fluid" alt=" " />
              <h5>Sanjaya Tour</h5>
            </a>
          </div>
        </Carousel>
      </div>
    );
  }
}

export default Travel;
